import { types } from "mobx-state-tree";

export const CityModel = types.model("CityModel", {
  id: types.maybeNull(types.string),
  cityID: types.maybeNull(types.number),
  cityOrder: types.maybeNull(types.number),
  cityTitle: types.maybeNull(types.string),
  name: types.maybeNull(types.string)
});
